import React from 'react'
import { withStyles } from 'material-ui/styles'
import Icon from 'material-ui/Icon'

const styles = theme => ({
    goodState: {
        color: theme.palette.success
    },
    avgState: {
        color: '#FFD700'
    },
    poorState: {
        color: theme.palette.fail
    }
});

class FiberSetReferencePowerStatus extends React.Component {

    render() {
        const { classes, status } = this.props

        if (status === 'Good') {
            return (
                <React.Fragment>
                    <Icon className={classes.goodState}>check_circle</Icon>
                </React.Fragment>
            )
        } else if (status === 'Avg') {
            return (
                <React.Fragment>
                    <Icon className={classes.avgState}>check_circle</Icon>
                </React.Fragment>
            )
        } else if (status === 'Poor') {
            return (
                <React.Fragment>
                    <Icon className={classes.poorState}>cancel</Icon>
                </React.Fragment>
            )
        } else {
            return null
        }
    }
}

export default withStyles(styles)(FiberSetReferencePowerStatus)
